import { axiosPost, axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls, roles } from 'consts'
import { getCustomData } from 'shared/components/App/Auth'
import displayGenError from 'shared/utils/displayGenError'
import hasAnyRole from 'shared/utils/hasAnyRole'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  setError: Function
  id: string | undefined
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  const isAdmin = hasAnyRole([roles.superAdmin, roles.admin])
  const isSuperAdmin = hasAnyRole([roles.superAdmin])
  const currentUserId = getCustomData('userId')

  //remove relational attributes used in react-select and replace by relational keys
  //nullish-safe operator || '' is important, b/c if we replaced '' by null then no data will be received in the model,
  //so the value won't be overwritten
  props.data['country_id'] = props.data.country?.id ?? ''
  props.data['state_id'] = props.data.state?.id ?? ''
  props.data['role_api'] = props.data.role ?? ''

  if (!isAdmin) {
    delete props.data['status']
  }

  if (!isSuperAdmin && props.id === currentUserId) {
    delete props.data['role']
    delete props.data['status']
  }

  let centers: Array<number> = []
  let customers: Array<number> = []

  if (isSuperAdmin) {
    props.data.customers.forEach((c) => {
      customers.push(c.id)
      const centersByCustomer = props.data['centersbycustomer' + c.id] ?? []
      centers = [...centers, ...centersByCustomer.map((c) => c.id)]
    })
  } else {
    centers = props.data['centers'] instanceof Array ? props.data['centers'].map((c) => c.id) : []
  }

  const formData = {
    ...props.data,
  }

  const saveCustomersAndCenters = async (responseData: any) => {
    const userId = responseData?.data?.id

    if (isSuperAdmin) {
      const payload = {
        user_id: userId,
        customers: customers,
      }
      await axiosPut(apiUrls.usersToCustomers + '/' + apiUrls.actionSave, payload, () => {
        return false
      })
    }

    return await saveCenters(userId)
  }

  const saveCenters = (userId: string | number) => {
    const payload = {
      user_id: userId,
      centers: centers,
    }
    return axiosPut(apiUrls.usersToCenters + '/' + apiUrls.actionSave, payload, () => {
      return false
    })
  }

  const catchFn = (err: AxiosError) => {
    if (err.response!.status === 422) {
      setFormValidationError(err, props.setError)
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  if (props.id === undefined) {
    response = await axiosPost(apiUrls.users, formData, catchFn).then((res) => {
      return res === undefined ? false : saveCustomersAndCenters(res)
    })
  } else {
    response = await axiosPut(apiUrls.users + '/' + props.id, formData, catchFn).then((res) => {
      return res === undefined ? false : saveCustomersAndCenters(res)
    })
  }

  return response
}

export default submitForm
